import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { getPendingSelections } from '../services/firebase';

interface PendingMatchesContextType {
  pendingCount: number;
  refreshPendingMatches: () => Promise<void>;
}

const PendingMatchesContext = createContext<PendingMatchesContextType | undefined>(undefined);

export const PendingMatchesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [pendingCount, setPendingCount] = useState(0);
  const { user: currentUser } = useAuth();

  const refreshPendingMatches = async () => {
    if (!currentUser?.uid) {
      setPendingCount(0);
      return;
    }

    try {
      const { fuckSelections, marrySelections } = await getPendingSelections(currentUser.uid);
      const total = fuckSelections.length + marrySelections.length;
      setPendingCount(total);
      console.log(`📋 Updated pending matches count: ${total}`);
    } catch (error) {
      console.error('❌ Error refreshing pending matches:', error);
      setPendingCount(0);
    }
  };

  // Load pending matches when user changes
  useEffect(() => {
    refreshPendingMatches();
  }, [currentUser?.uid]);

  return (
    <PendingMatchesContext.Provider value={{ pendingCount, refreshPendingMatches }}>
      {children}
    </PendingMatchesContext.Provider>
  );
};

export const usePendingMatches = () => {
  const context = useContext(PendingMatchesContext);
  if (!context) {
    throw new Error('usePendingMatches must be used within a PendingMatchesProvider');
  }
  return context;
};